/* eslint-disable react/require-default-props */
import React, { ReactNode } from 'react';
import url from '@/utils/config';

type Props = {
  variant: 'primary' | 'secondary';
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  onClick: (e: React.UIEvent<Element, UIEvent>) => void;
  children: ReactNode;
  className?: string;
  icon?: boolean;
  ariaLabel?: string;
};

/**
 * 画面内操作に使う共通ボタンコンポーネント。
 * @param props 見た目、クリック処理、無効化状態などのボタン設定
 * @returns ボタン表示
 */
const Button = ({
  variant,
  type = 'submit',
  disabled = false,
  onClick,
  children,
  className = '',
  icon = true,
  ariaLabel,
}: Props) => {
  return (
    <button
      className={`m-button__inner ${variant === 'secondary' ? 'm-button--sec' : ''} ${className}`}
      type={type}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={onClick}
    >
      <span className='m-button__txt'>{children}</span>
      {/* 矢印アイコン不要な場面もあるため、表示可否を呼び出し元で切り替えられるようにする。 */}
      {icon && (
        <img className='m-button__icon' src={url('/images/icon_arrow_right-02.svg')} alt='' />
      )}
    </button>
  );
};

export default Button;
